import { ReportHeader } from "../../types";

export interface ContainerProps {}

export interface ContainerData {}

export interface ContainerComputed {}

export interface ContainerMethods {}

export interface Data {
  defaultYear: number;
  isToggleSideNav: { [key: number]: boolean };
  selectedWeek: object;
}

export interface Computed {
  yearsReports: { [key: number]: MonthMappedReport[] };
}

export interface Props {
  dataArray: ReportHeader[];
}

export interface Methods {
  toggleSideNav: (year: number) => void;
  selectWeekly: (data: ReportHeader) => void;
}

// store/typesにあったほうが良いのでしょうか？
export class MonthMappedReport {
  year: number;
  month: number;
  reports: ReportHeader[];
  monthlyReport: ReportHeader | null;
  constructor(report: ReportHeader) {
    this.year = report.year;
    this.month = report.month;
    if (report.isMonthlyReport()) {
      this.monthlyReport = report;
      this.reports = [];
    } else {
      this.monthlyReport = null;
      this.reports = [report];
    }
  }

  public addReport(report: ReportHeader) {
    if (report.isMonthlyReport()) {
      this.monthlyReport = report;
    } else {
      this.reports.push(report);
    }
  }

  public static makeMonthMappedReports(
    dataArray: ReportHeader[]
  ): MonthMappedReport[] {
    let reports: MonthMappedReport[] = [];
    dataArray.forEach(data => {
      let mappedReport = reports.find(
        report => report.year == data.year && report.month == data.month
      );
      if (mappedReport) {
        mappedReport.addReport(data);
      } else {
        reports.push(new MonthMappedReport(data));
      }
    });
    return reports;
  }
}
